export const getPortalContainer = (): HTMLElement => document.getElementById('portals-container') || document.body;
